import { render, staticRenderFns } from "./TableVideoAccess.vue?vue&type=template&id=2c5e4d7b"
import script from "./TableVideoAccess.js?vue&type=script&lang=js&external"
export * from "./TableVideoAccess.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports